import { createFileRoute } from "@tanstack/react-router";
import CultivationCheck from "../../app/views/cultivation/cultivationCheck";

const ElisaCultivationCheck = () => (
  <CultivationCheck cultivationType="elisa" />
);

export const Route = createFileRoute("/elisa/check")({
  component: ElisaCultivationCheck,
});
